import { render, staticRenderFns } from "./ObjectiveEditorAdmin.vue?vue&type=template&id=6b1e1118&scoped=true&"
import script from "./ObjectiveEditorAdmin.vue?vue&type=script&lang=js&"
export * from "./ObjectiveEditorAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ObjectiveEditorAdmin.vue?vue&type=style&index=0&id=6b1e1118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1e1118",
  null
  
)

export default component.exports